import { render, staticRenderFns } from "./AddResellerProductComponent.vue?vue&type=template&id=ed2b932a&"
import script from "./AddResellerProductComponent.vue?vue&type=script&lang=js&"
export * from "./AddResellerProductComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports